<template>
  <main class="mdl-layout__content">
    <div class="page-content">
      <!--
      <h1 class="mdl-typography--headline">Arkiv</h1>
      <h2 class="mdl-typography--title">Kontroll av tekniske defekter</h2>
      -->
      <div class="mdl-cell mdl-cell--12-col">
        <div style="width:100%" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
          <input v-model="search" class="mdl-textfield__input" type="text" id="search" @input="onSearchChange">
          <label class="mdl-textfield__label" for="search">Søk</label>
        </div>
      </div>
      <table class="mdl-data-table mdl-shadow--2dp">
        <thead>
        <tr>
          <th class="mdl-data-table__cell--non-numeric">Dato</th>
          <th class="mdl-data-table__cell--non-numeric">Reg.Nr</th>
          <th class="mdl-data-table__cell--non-numeric">Status</th>
          <th class="mdl-data-table__cell--non-numeric">IP</th>
          <th class="mdl-data-table__cell--non-numeric">Verksted</th>
        </tr>
        </thead>
        <tbody>
        <tr :id="'log-' + log.id" v-for="log in reportsLogs">
          <td class="mdl-data-table__cell--non-numeric" v-text="formatDate(log.created_at)"></td>
          <td class="mdl-data-table__cell--non-numeric" v-text="log.license.toUpperCase()"></td>
          <td class="mdl-data-table__cell--non-numeric" v-text="log.content"></td>
          <td class="mdl-data-table__cell--non-numeric" v-text="log.IP"></td>
          <td class="mdl-data-table__cell--non-numeric" v-text="log.user_name"></td>
        </tr>
        <tr v-if="!reportsLogs.length && !$root.ui.isLoading()">
          <td colspan="7" class="mdl-data-table__cell--non-numeric">No logs</td>
        </tr>
        </tbody>
      </table>
    </div>
  </main>
</template>

<script>

  import utils from '../mixins/utils.js'

  export default {
    data () {
      return {
        search: ''
      }
    },
    mixins: [utils],
    computed: {
      reportsLogs() {
        return this.$store.getters.reports_logs
      }
    },
    methods: {
      getReportsLogs(search, license){
        var self = this
        self.$root.ui.loading.push('getReportsLogs')
        return this.$store.dispatch('getReportsLogs', {search: search, license: license}).then(function(res){
          self.$root.ui.stopLoading('getReportsLogs')
        })
      },
      onSearchChange(){
        let license = null
        if( this.$route.params.license )
          license = this.$route.params.license
        this.$store.commit('set', {type: 'reports_logs', val: []})
        return this.getReportsLogs(this.search, license)
      }
    },
    created: function(){
      this.getReportsLogs(this.search, this.$route.params.license)
    },
    beforeRouteUpdate (to, from, next) {
      next()
      this.getReportsLogs(this.search, to.params.license)
    },
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ReportsLogs.vue?f25b86a6